import $ from 'jquery';
//import whatInput from 'what-input';

window.$ = $;
window.jQuery = $;

import Foundation from 'foundation-sites';

Foundation.addToJquery($);
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

// import 'tablesaw/dist/tablesaw.jquery';
import libs from './lib/dependencies';

window.libs = libs;

jQuery(document).foundation();

import 'jquery-modal';

libs.AOS.init();

// SVG Injector
// Elements to inject
var mySVGsToInject = document.querySelectorAll('img.inject-me');

// Options
var injectorOptions = {
    evalScripts: 'once',
    pngFallback: 'assets/png'
};

var afterAllInjectionsFinishedCallback = function (totalSVGsInjected) {
    // Callback after all SVGs are injected
    console.log('We injected ' + totalSVGsInjected + ' SVG(s)!');
};

var perInjectionCallback = function (svg) {
    // Callback after each SVG is injected
    console.log('SVG injected: ' + svg);
};

// create injector configured by options
var injector = new libs.svgInjector(injectorOptions);

// Trigger the injection
injector.inject(
    mySVGsToInject,
    afterAllInjectionsFinishedCallback,
    perInjectionCallback
);

// slick carousel
$(".content-carousel").slick({
    // normal options...
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    centerMode: true,
    focusOnSelect: true,
    // the magic
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            infinite: true
        }
    }, {
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
            dots: true
        }
    }, {
        breakpoint: 300,
        settings: "unslick" // destroys slick
    }]
});

// tablesaw table plugin
// $(function () {
//   $(document)
//     .foundation()
//     .trigger('enhance.tablesaw');
// });

// var TablesawConfig = {
//   swipeHorizontalThreshold: 15
// };

// app dashboard toggle
$('[data-app-dashboard-toggle-shrink]').on('click', function (e) {
    e.preventDefault();
    $(this).parents('.app-dashboard').toggleClass('shrink-medium').toggleClass('shrink-large');
});


$(".counter").each(function () {
    var $this = $(this),
        countTo = $this.attr("data-count");

    $({countNum: $this.text()}).animate(
        {
            countNum: countTo
        },

        {
            duration: 2500,
            easing: "linear",
            step: function () {
                $this.text(Math.floor(this.countNum));
            },
            complete: function () {
                $this.text(this.countNum);
            }
        }
    );
});

$('.hamburger-icon').click(function () {
    $('body, .mobile-menu').toggleClass('mobile-menu-active');
});


//Search filter on mobile start
function searcFilter() {
    $('.search-page .mobile-filters-btn').on('click', function () {
        $('.search-page .filters-wrapper').addClass('active');
        $('body, .mobile-menu').addClass('mobile-menu-active');
    });

    $('.search-page .mobile-block .close').on('click', function () {
        $('.search-page .filters-wrapper').removeClass('active');
        $('body, .mobile-menu').removeClass('mobile-menu-active');
    });
}

searcFilter();
//Search filter on mobile end


//Dropdown profile menu on header start
$(document).mouseup(function (e) {
    var customerDropdown = $('.header-my-info');
    var arrow = $('.header-my-info .customer-name');
    if (!customerDropdown.is(e.target)
        && customerDropdown.has(e.target).length === 0) {
        arrow.removeClass('active');
        $('.header-my-info .dropdown-list').removeClass('active');
    }
    // if (!arrow.is(e.target)
    //     && arrow.has(e.target).length === 0) {
    //     arrow.removeClass('active');
    // }

});

const isMobile = /Android.+Mobile|webOS|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
if (isMobile) {
    $('.header-my-info > div').on('click', function () {
        $('.header-my-info .customer-name').toggleClass('active');
        $('body, .mobile-menu').removeClass('mobile-menu-active');
        if ($('.header-my-info .customer-name').hasClass('active')) {
            $('.header-my-info .dropdown-list').addClass('active');
        } else {
            $('.header-my-info .dropdown-list').removeClass('active');
        }
    });
    $('.header-my-info .header-my-info-dropdown a').on('click', function (e) {
        e.preventDefault();
    });
} else {
    $('.header-my-info > div').hover(function () {
        $('.header-my-info .customer-name').toggleClass('active');
        $('body, .mobile-menu').removeClass('mobile-menu-active');
        if ($('.header-my-info .customer-name').hasClass('active')) {
            $('.header-my-info .dropdown-list').addClass('active');
        } else {
            $('.header-my-info .dropdown-list').removeClass('active');
        }
    });
}
//Dropdown profile menu on header end

//Profile actions on mobile start
function profileActions() {
    if ($(window).width() < 550) {
        $('.card-description .profile-actions').appendTo(".card.cv-card");
    } else {
        $('.profile-actions').appendTo('.card-description');
    }
}

profileActions();
$(window).on('load resize', profileActions);
//Profile actions on mobile end

//Show all description start
// $('.employer-description .show-all-description').on('click', function () {
//
//     $('.employer-description .description-wrap').animate({
//         height: "100%"
//     }, 500);
//
//     if($(this).hasClass('active')) {
//         $('.employer-description .description-wrap').animate({
//             height: "140px"
//         }, 500);
//     }
//
//     $(this).toggleClass('active');
//     if($(this).hasClass('active')) {
//         $(this).html('Згорнути').append('<img src="../../assets/frontend/img/show-more-descr-icon.svg">');
//     } else {
//         $(this).html('Розгорнути').append('<img src="../../assets/frontend/img/show-more-descr-icon.svg">');
//     }
// });
//Show all description end


//Close popup with replay send pass
$('.end-registration-wrap .close-btn').on('click', function () {
    $('.end-registration-wrap').addClass('hide');
});

$('.payment-popup .close-btn').on('click', function () {
    $('.payment-popup').addClass('hide');
});


//Publised / Unpubliseh cv
$('.card .f-switch-checkbox').each(function () {
    var input = $(this).find('input');
    var parentDiv = $(this).closest('.card');
    if (parentDiv.hasClass('published')) {
        input.removeClass('hide').addClass('show');
    } else {
        input.addClass('hide').removeClass('show');
    }
});


// resent email for register in header line
$(document).on('click', '#resent-email', function (e) {
    $.ajax({
        url: '/send_confirm_email',
    }).done(function (data) {
        console.log(data);
    })
});


//Humburger menu
$('.hamburger-icon').on('click', function () {
    if ($('.index.default').hasClass('mobile-menu-active')) {
        $(this).addClass('active');
    } else {
        $(this).removeClass('active');
    }
});


//role-selection-link
function roleSelection() {
    if ($(window).width() <= 640) {
        $('.role-selection-link').appendTo('.top-section .right-block');
        $('.role-selection-link').addClass('mobile');
    } else {
        $('.role-selection-link').prependTo('header .top-section .right-block');
        $('.role-selection-link').removeClass('mobile');
    }
}

roleSelection();
$(window).on('resize', function () {
    roleSelection();
});

$('.search-type-switcher').on('change', function () {
    var type = $(this).val();
    var action = $(this).find('option:selected').attr('data-href');
    $('.main-page-search-form').attr('action', action);
    $('.search-by-filters .active').removeClass('active').css('display', 'none');
    $('.main-page-filters-' + type).addClass('active').css('display', 'block');
});

// More links on cv-card
$('.card .more-info').hover(function () {
    $(this).toggleClass('active');
});


//Slider with photo
$('.gallery').on('init', function () {
    if (!($('.slider .slick-slide').length < 3)) {
        $('.slider__arrow').hide();
    }
});

$('.gallery').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

// show tips for short name in CV list
$('.short-cv-name').hover(function () {
    $(this).parent('.name-wrapper').find('.full-cv-name').css('display', 'block');
}, function () {
    $(this).parent('.name-wrapper').find('.full-cv-name').css('display', 'none');
});


//Extra services on cart page
$('.services-package .extra-services .title p').on('click', function () {
    $('.services-package .extra-services ul').toggleClass('active');
    $(this).toggleClass('active');
});


//Payment description text
$('.payment-page div.pay-item').click(function () {
    // e.preventDefault();

    $('.payment-page div.pay-item').removeClass('active');
    $(this).addClass('active');
});


//Close cookie popup
$('.cookie-wrap .close-popup').on('click', function () {
    $('.cookie-wrap').addClass('hidden');
});

//Salary hint
if (isMobile) {
    $('.hint').on('click', function () {
        $('.title-hint').toggleClass('active');
    });
    $(document).mouseup(function (e) {
        var hint = $('.hint');
        if (!hint.is(e.target)
            && hint.has(e.target).length === 0) {
            $('.title-hint').removeClass('active');
        }
    });
}

//All hint on mobile
if (isMobile) {
    $('.form-group .section-2 .helpfyll-popup').addClass('active');
} else {
    $('.form-group .section-2 .helpfyll-popup').removeClass('active');
}

//Compare popup on toch devices
if (isMobile) {
    $('.add-to-compare-wrap .disabled').on('click', function () {
        $('.add-to-compare-wrap .disabled span').toggleClass('active');
    });
    $(function ($) {
        $(document).mouseup(function (e) {
            var compare = $(".add-to-compare-wrap .disabled");
            if (!compare.is(e.target)
                && compare.has(e.target).length === 0) {
                $('.add-to-compare-wrap .disabled span').hide();
            }
        });
    });
} else {
    $('.add-to-compare-wrap .disabled span').removeClass('active');
}


//Show more on vacancy description
$('.vacancy-item .descr-text p').each(function () {
    if ($(this).height() > 200) {
        $(this).siblings('.show-more').addClass('visible');
    }
});
$('.vacancy-item .descr-text .show-more.visible').on('click', function () {
    $(this).parent('.descr-wrap').addClass('visible');
    $(this).removeClass('visible');
});


$('.all-package .accordion-item .servises-info-btn').click(function (e) {
    $(this).parents('.accordion').foundation('toggle', $(this).parents('.accordion-item').find('.accordion-content'));
});

//popup close
$(document).on('click', '.close-popup-btn', function () {
    $(this).parents('.popup-wrapper').remove();
    if ($(this).hasClass('page-reload')) {
        window.location.reload();
    }

    if ($(this).hasClass('remove-body-fixed')) {
        $('body').removeClass('fixed')
    }
});

//check user paid for vacancy create
$(document).on('click', '.add-vacancy-btn', function (e) {
    let btn = $(this);
    if ('1' !== btn.attr('data-can-create-vacancy')) {
        e.preventDefault();
        $.post('/service-pack/vacancy-create-tariff-info-popup').done(function (data) {
            if (data.popup) {
                $('body').append(data.popup);
            }
        });
    }
});

//check company paid for message to user
$(document).on('click', '.company-message-to-worker-btn', function (e) {
    let btn = $(this);
    if ('1' !== btn.attr('data-can-message-to')) {
        e.preventDefault();
        $.post('/chat/company-try-message-to-worker-info-popup').done(function (data) {
            if (data.popup) {
                $('body').append(data.popup);
            }
        });
    }
});

let $scrollTo = $('.scroll-to-this-elem');
if ($scrollTo.length) {
    let $container = $('html,body');
    $(document).ready(function () {
        $container.animate({
            scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop() - 120,
            scrollLeft: 0
        }, 300);
    });
}


$(document).on('click', '.buy-more-service-btn', function (e) {
    let type = $(this).attr('data-service-type');
    if (type !== 'usual') {
        e.preventDefault();
        $.post('/service-pack/buy-more-services', {type: type}).done(function (data) {
            if (data.popup) {
                $('body').append(data.popup);
            }
        });
    }
});

$(document).on('click', '.use-service-btn', function (e) {
    e.preventDefault();

    let serviceInOrderId = $(this).attr('data-service-in-order-id');
    $.post('/service-pack/use-service', {serviceInOrderId: serviceInOrderId}).done(function (data) {
        if (data.popup) {
            $('body').append(data.popup);
        }
    });
});

$(document).on('click', '.show-delete-order-popup', function (e) {
    e.preventDefault();
    let serviceOrderId = $(this).attr('data-service-order-id');
    $.post('/service-order-delete-popup/' + serviceOrderId).done(function (data) {
        if (data.popup) {
            $('body').append(data.popup);
        }
    });
});

$(document).on('mouseup', 'body', function (e) {
    if (!$('.progres-popup .popup-content').is(e.target)
        && $('.progres-popup .popup-content').has(e.target).length === 0) {
        $('.progres-popup').hide();
        $('body').removeClass('fixed');
    }
});

$(document).on('click', '.delete-order-btn', function (e) {
    let serviceOrderId = $(this).attr('data-service-order-id');
    $.post('/service-order-delete', {serviceOrderId: serviceOrderId});
});

//INCREASE OR DECREMENT vacancy or invitation amount and buy service

$(document).on('click', '.buy-service-in-tariff', function () {
    let amount = $(this).parents('.popup-wrapper').find('input.service-amount').val();
    $.post('/service-pack/buy-service', {type: $(this).attr('data-type'), amount: isNaN(amount) ? 1 : amount});
});

$(document).on('click', '.minus-input-val', function () {
    changeNumberInputVal($(this), '-');
});

$(document).on('click', '.plus-input-val', function () {
    changeNumberInputVal($(this), '+');
});

function changeNumberInputVal(el, sign) {
    let input = el.parent('.count-input').find('input.service-amount');
    let val = parseInt(input.val());
    if (isNaN(val)) {
        input.val(1);
    } else {
        if (sign === '-' && val > 1) {
            input.val(--val);
        } else if (sign === '+') {
            input.val(++val);
        }
    }
}

//How site work slider
function setProgress(index) {
    var calc = ((index + 1) / ($slider.slick('getSlick').slideCount)) * 100;

    $progressBar
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc);

    $progressBarLabel.text(calc + '% completed');
}

let $slider = $('.how-site-work-slider');
let $progressBar = $('.progress');
let $progressBarLabel = $('.slider__label');

$slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    setProgress(nextSlide);
});

$('.how-site-work-slider').on("init", function (event, slick) {
    // $(".count").text('0' + parseInt(slick.currentSlide + 1) + ' / ' + '0' + slick.slideCount);
    $('.count').html("<p>0" + parseInt(slick.currentSlide + 1) + "</p>" + " / " + "0" + slick.slideCount);
});

$('.how-site-work-slider').on("afterChange", function (event, slick, currentSlide) {
    // $(".count").text('0' + parseInt(slick.currentSlide + 1) + ' / ' + '0' + slick.slideCount);
    $('.count').html("<p>0" + parseInt(slick.currentSlide + 1) + "</p>" + " / " + "0" + slick.slideCount);
});

$('.how-site-work-slider').slick({
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 1500
});

setProgress(0);

//Helpfull text
$('.how-site-work .helpful-info-title').on('click', function () {
    $(this).toggleClass('active');
    $('.how-site-work .helpful-info-text').toggleClass('open');
});

//Up button
$('.up-btn').on('click', function () {
    $('html, body').animate({scrollTop: 0}, 500);
    return false;
});

$(window).on('scroll', function () {
    let windowHeight = $(window).height();

    let btnPosition = $('.up-btn');
    if (btnPosition.length > 0) {
        btnPosition.offset().top;
        if (btnPosition > windowHeight * 2) {
            $('.up-btn').addClass('active');
        } else {
            $('.up-btn').removeClass('active');
        }
    }
});